<router-outlet>
  <div class="container">
    <div class="row">
      <div class="spinner-container">
        <div class="sk-cube-grid">
          <div class="sk-cube sk-cube1"></div>
          <div class="sk-cube sk-cube2"></div>
          <div class="sk-cube sk-cube3"></div>
          <div class="sk-cube sk-cube4"></div>
          <div class="sk-cube sk-cube5"></div>
          <div class="sk-cube sk-cube6"></div>
          <div class="sk-cube sk-cube7"></div>
          <div class="sk-cube sk-cube8"></div>
          <div class="sk-cube sk-cube9"></div>
        </div>
      </div>
    </div>
  </div>
</router-outlet>

@if (showRecaptchaBadge$ | async) {
  <div class="custom-recaptcha-badge">
    <div class="badge-icon">
      <img src="/assets/images/recaptcha-logo.png" alt="reCAPTCHA" width="32" height="32" />
    </div>
    <div class="badge-content">
      <span class="badge-tagline">{{ 'theme_base.recaptcha_protected' | translate }}</span>
      <div class="badge-links">
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">{{ 'theme_base.recaptcha_privacy' | translate }}</a>
        <span>-</span>
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener">{{ 'theme_base.recaptcha_terms' | translate }}</a>
      </div>
    </div>
  </div>
}

